import React, { useMemo } from 'react'

import { ThemeProvider } from "@pixel/core";
import { createInternalTheme } from "@pixel/internal/styles";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LocalizationProvider from '../contexts/Localization/LocalizationProvider'
import DomainProvider from '../contexts/Domain';
import { LocalizationValues } from '../contexts/Localization/LocalizationTypes';
import FieldList from "./FieldList";

declare global {
    interface Window {
        i18n: {
            automationEngine: LocalizationValues
        },
        _jvselfUser: {
            companyEId: string
            companyName: string
            eid: string
            email: string
            firstName: string
            fullName: string
            lastName: string
            locale: {
                language: string
                languageTag: string
                // Implement the rest if needed
                [key: string]: any
            }
            // Implement the rest if needed
            [key: string]: any
        }
    }
}

const queryClient = new QueryClient()

export const App = () => {
    const theme = useMemo(() => createInternalTheme({ darkMode: false, theme: {} }), [])

    return (
        <DomainProvider urls={window.jvUrls}>
            <LocalizationProvider locale={window._jvselfUser.locale.languageTag} translations={window.i18n.automationEngine}>
                <QueryClientProvider client={queryClient}>
                    <ThemeProvider theme={theme}>
                        <FieldList />
                    </ThemeProvider>
                </QueryClientProvider>
            </LocalizationProvider>
        </DomainProvider>
    )
}

export default App
export { react2angular } from "../lib/react2Angular";
